// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload
import './autoload/_bootstrap'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateCaseStudies from './routes/case-studies';
import templateWhitePages from './routes/white-pages';
import templateContactUs from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateCaseStudies,
  templateWhitePages,
  templateContactUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/web/app/themes/main-theme/resources/assets/scripts/main.js